import dayjs from "dayjs"
export const formatDateTime = (date: any, format= "MMM D, YYYY h:mm:ss A") => {
    return dayjs(date).format(format)
}